<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import subtenant from "@/services/subtenants";
import emailService from "@/services/emailService";

export default {
  computed: {
    ...mapGetters("visitors", ["getEmail", "getFirstName", "getLastName", "getPostcode", "getStreet", "getCity", "getCompanyName", "getID", "getcountryItem", "countryItems", "getBecomeAwareOf", "subdomain"]),
    ...mapGetters("environement", ["subdomain"]),
  },
  methods: {
    async companyNameExists() {
      let tenantExists = await subtenant.subTenantExist(this.getCompanyName);
      return tenantExists;
    },
    async createSubTenant(spamProtectionAnswer) {
      //token must be set
      if (spamProtectionAnswer == null) {
        return false;
      }

      //prepare enums
      let countryItem = this.countryItems.find((p) => p.value === this.getcountryItem);

      //prepare body
      let body = {
        companyName: this.getCompanyName,
        email: this.getEmail,
        firstName: this.getFirstName,
        lastName: this.getLastName,
        postCode: this.getPostcode,
        street: this.getStreet,
        city: this.getCity,
        country: countryItem ? countryItem.name : "",
        becomeAwareOf: this.getBecomeAwareOf ? this.getBecomeAwareOf : "",
        spamProtectionAnswer: spamProtectionAnswer,
      };
      //console.log(body);

      //register new subtenant (creates an account group, account, assign roles and so on)
      let response = await subtenant.register(body);

      return response;
    },
    async sendEmail(body) {
      body.distributor = "RAFI";

      //body must be set
      if (body == null) {
        return false;
      }
      let response = await emailService.sendContactFormEmailAsync(body);
      return response != null;
    },
  },
};
</script>
